import request from "../../../../../utils/request";
import { requestConfig } from "../../../../../config/apiResource";


export function unClaimedMeta() {
  let typeData = "unclaimed-dividend-and-redimption";

  return (dispatch) => {
    return request(requestConfig.allSectionsMeta(typeData))
      .then((json) => {
        json && dispatch({ type: "UNCLAIMED_META", data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with verify pan folio data: " + error);
      });
  };
}
// reducer
export default function unclaimedDataReducer(state = {}, action) {
  switch (action.type) {
    case "UNCLAIMED_META":
      return { ...state, metaData: action.data };
    default:
      return state;
  }
}
